import React from 'react';
import { connect } from 'redux-bundler-react';
import { markdown } from 'markdown';
import xhr from 'xhr';
import json2md from 'json2md';

const testData = json2md([
  
  { h4: "Help Documentation" },
  { ul: 
    [
      {
        link:{
          title:"Help Documentation", 
          source:"http://maps.mmc.usace.army.mil/dataviewer/img/Help.pdf"
        }
      }
    ]
  },
  { h4: "Contact Information" },
  { ol: [
      {
        link: {
          title:"NID@usace.army.mil", 
          source:"mailto:NID@usace.army.mil"
        }
      }
    ]
  }

]);

class DatasetInfo extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      __html: '<p>Loading</p>'
    }
    
    this.close = this.close.bind(this);
    // this.renderContent = this.renderContent.bind(this);
    // this.renderMarkdown = this.renderMarkdown.bind(this);
  }

  // componentDidMount(){
  //   return this.renderContent();
  // }

  close() {
    const { doCloseModalWindow } = this.props;
    doCloseModalWindow();
  }

  // renderMarkdown(content){
  //   this.setState({
  //     __html: markdown.toHTML(content, 'Maruku')
  //   })
  // }

  // renderContent(){
    
  //   return this.renderMarkdown(testData);
  // }
  

  render(){
    const { theme} = this.props;
    return (
      <div>
        <div className={"modal-header " + theme}>
          FIM Viewer Help
        </div>        
        <div
          className={"modal-body thin-scrollbar" + theme}
          style={{ height: (window.innerHeight * 0.50), top: 0, bottom: 0, left: 0, right: 0, overflow: 'auto'}}
        >
          <div>
            <h4>
              Note: All mapping data is in the NAVD88 datum.
            </h4>
            <h4>
              Help Documentation
            </h4>
            <ul>
              <li>
                <a href={"./img/Help.pdf"} target="_blank" rel="noopener noreferrer">Help Documentation</a>
              </li>
            </ul>
            <h4>
              Contact Information
            </h4>
            <ul>
              <li>
                <a href={"mailto:NID@usace.army.mil"} target="_blank" rel="noopener noreferrer">NID@usace.army.mil</a>
              </li>
            </ul>

            <h4>
              Scenario Definitions
            </h4>
            <p>
              For specific scenario definitions, see the <a href={"./img/Help.pdf"} target="_blank" rel="noopener noreferrer">Help Documentation</a>
            </p>
            <p>
              Maximum High (MH) is the pool level near the top of dam resulting from water flowing into the reservoir from heavy rainfall, snowmelt, or other significant high-water events.
            </p>
            <p>
              Intermediate High (IH) is the pool level filling the storage capacity of the dam resulting from water flowing into the reservoir from heavy rainfall, snowmelt, or a combination of the two events.  The spillway releases excess water. 
            </p>
            <p>
              Top of Active Storage (TAS) is the pool level filling the storage capacity of the dam.
            </p>
            <p>
              High Pool is a yearly average high pool level not filling the storage capacity of the dam. Also called the Security Scenario (SS).
            </p>
            <p>
              Normal is the pool level the dam maintains throughout the year when not in a flood operation. Minimal outflow releases. Also called the Normal High (NH).
            </p>
          </div>
        </div>
        <div className="modal-footer">
          <button className={"btn btn-theme " + theme} onClick={this.close}>
            Close
          </button>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'doCloseModalWindow',
  DatasetInfo
);